<template>
  <div class="overflow-auto" style="max-height: 75vh">
    <Table
      :columns="columns"
      :data="rows"
      :is-row-clickable="statsClickable"
      @row-click="handleRowClick"
      @sort="handleSort"
      :order="computedOrder"
    >
      <template #name="{ row }">
        <div>{{ row.name }}</div>
      </template>
      <template #sales_count="{ row }">
        <div class="text-center">{{ row.sales_count }}</div>
      </template>
      <template #active_sales_count="{ row }">
        <div class="text-center">{{ row.active_sales_count }}</div>
      </template>
      <template #cancellation_rate="{ row }">
        <div class="text-center">{{ row.cancellation_rate }} %</div>
      </template>
      <template #sales_count_target="{ row }">
        <div class="text-center">{{ row.sales_count_target }}</div>
      </template>
      <template #sales_count_result_target="{ row }">
        <div class="text-center">
          <TargetCell :value="row.sales_count_result_target" />
        </div>
      </template>
      <template #sales_count_projection="{ row }">
        <div class="text-center">
          {{ row.sales_count_projection }}
        </div>
      </template>
      <template #sales_count_projection_variation="{ row }">
        <div class="text-center">
          <VariationCell :value="row.sales_count_projection_variation" />
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import { Table } from "@estaly/ui";
import TargetCell from "@/components/analytics/retail/utils/TargetCell.vue";
import VariationCell from "@/components/analytics/retail/utils/VariationCell.vue";

export default {
  components: {
    Table,
    TargetCell,
    VariationCell,
  },

  props: {
    stats: {
      type: Array,
      required: true,
    },
    total: {
      type: Object,
      required: true,
    },
    currentMonth: {
      type: String,
      required: true,
    },
    statsClickable: {
      type: Boolean,
      default: false,
    },
    showTargetColumns: {
      type: Boolean,
      default: false,
    },
    currentSortColumn: {
      type: String,
      default: null,
    },
    currentSortOrder: {
      type: String,
      default: null,
    },
  },

  data: () => {
    return {
      sortColumn: null,
      sortOrder: null,
      commonColumns: [
        {
          field: "name",
          label: "Nom",
          slot: "name",
          sortable: true,
          headerGroup: "",
        },
        {
          field: "sales_count",
          label: "Contrats vendus",
          slot: "sales_count",
          sortable: true,
          headerGroup: "",
        },
        {
          field: "active_sales_count",
          label: "Contrats actifs",
          slot: "active_sales_count",
          sortable: true,
          headerGroup: "",
        },
        {
          field: "cancellation_rate",
          label: "Taux de résiliation",
          slot: "cancellation_rate",
          sortable: true,
          headerGroup: "",
        },
      ],
      targetColumns: [
        {
          field: "sales_count_target",
          label: "Objectif",
          slot: "sales_count_target",
          sortable: true,
          headerGroup: "",
        },
        {
          field: "sales_count_result_target",
          label: "Atteinte de l'objectif",
          slot: "sales_count_result_target",
          sortable: true,
          headerGroup: "",
        },
      ],
      projectionColumns: [
        {
          field: "sales_count_projection",
          label: "Contrats vendus",
          slot: "sales_count_projection",
          sortable: true,
          headerGroup: "Projection",
        },
        {
          field: "sales_count_projection_variation",
          label: "Évolution M-1",
          slot: "sales_count_projection_variation",
          sortable: true,
          headerGroup: "Projection",
        },
      ],
    };
  },

  computed: {
    columns() {
      return [...this.commonColumns, ...(this.showTargetColumns ? this.targetColumns : []), ...this.projectionColumns];
    },

    statsRows() {
      return this.stats || [];
    },

    totalRow() {
      return [this.total];
    },

    rows() {
      return [
        ...this.totalRow.map((row) => ({
          ...row,
          clickable: false,
          rowClass: "bg-gray-100",
        })),
        ...this.statsRows.map((row) => ({
          ...row,
          clickable: this.statsClickable,
          body: true,
          rowClass: "",
        })),
      ];
    },

    computedOrder() {
      if (!this.sortColumn) return null;
      return this.sortOrder === "desc" ? `-${this.sortColumn}` : this.sortColumn;
    },
  },

  methods: {
    handleRowClick(row) {
      if (!row.clickable) return;
      this.$emit("rowClicked", row);
    },

    handleSort(column) {
      if (this.sortColumn === column.field) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortColumn = column.field;
        this.sortOrder = "asc";
      }

      this.emitSortEvent();
    },

    emitSortEvent() {
      this.$emit("sortChanged", {
        column: this.sortColumn,
        order: this.sortOrder,
      });
    },
  },
};
</script>
